/**
 * 功能: 个人信息新增、修改数据的弹框组件
 */

<template lang="pug">
  el-dialog.dialog-wrap(title="个人" :visible.sync="isShowIndividual" :close-on-click-modal="false")
    el-form.demo-addIndividual(:model="userInfo" :rules="rules" ref="individualRef" label-width="120px" )
      el-row
        el-col.image
            el-form-item(label="头像" prop="avatar")
              el-upload.avatar-uploader( :action="GLOBAL.uploadHost+ 'individual/upload'"  :headers="headers" methods="post" :show-file-list="false" :on-success="success" accept="image/jpeg,image/png" :before-upload="beforeAvatarUpload")
                img.avatar(v-if="imageUrl" :src="GLOBAL.OSS+imageUrl")
                i(v-else class="el-icon-plus avatar-uploader-icon")
        el-col(:span="13")
          el-form-item(label="名称" prop="name")
            el-input(v-model="userInfo.name" placeholder="请输入名称(不可重复)" :size="GLOBAL.SIZE_OF_INPUTBOX" @blur="checkRepeat()")
        el-col(:span="16")
          el-form-item(label="性别" prop="gender" style="margin-top: 20px")
            el-radio(v-model="userInfo.gender" :label="0") 男
            el-radio(v-model="userInfo.gender" :label="1") 女
            el-radio(v-model="userInfo.gender" :label="2") 未知
        el-col(:span="13")
          el-form-item(label="加入团队")
            el-autocomplete(popper-class="my-autocomplete" v-model="inputValue" :fetch-suggestions="teamSearch" placeholder="请输入内容" @select="addTag")
              template(slot-scope="{ item }")
                div.name {{ '姓名：'+item.name }}
                span.description {{'描述：'+ item.description }}
            el-tag(:key="tag._id" v-for="tag in teamTags" closable :disable-transitions="false" @close="handleClose(tag)") {{tag.name}}
      el-row
        el-col(:span="22")
          el-form-item(label="添加描述" prop="description")
            el-input(v-model="userInfo.description" type="textarea" :rows="8" :size="GLOBAL.SIZE_OF_INPUTBOX" placeholder="请输入内容")
      el-row
        el-col(:span="11")
          el-form-item
            el-button(type="primary" @click="addIndividual" :size="GLOBAL.SIZE_OF_INPUTBOX") 保存
            el-button(@click="isShowIndividualDialog" :size="GLOBAL.SIZE_OF_INPUTBOX") 取消

</template>
<script>
import Individual from '@/apis/individual'
import passport from '@/javascripts/passport'
export default {
  components: {},
  props: {
    userInfo: {
      type: Object
    }
  },
  data () {
    return {
      headers: passport.headers(),
      imageUrl: '',
      isShowIndividual: false,
      teams: [],
      inputValue: '',
      teamTags: [],
      teamIds: [],
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.getAllTeam()
  },
  methods: {
    // 添加个人信息
    addIndividual () {
      this.$refs.individualRef.validate(valid => {
        if (valid) {
          this.$emit('saveIndividual', this.userInfo, () => {
            this.isShowIndividualDialog()
          })
        }
      })
    },
    // 是否显示dialog
    isShowIndividualDialog () {
      this.isShowIndividual = !this.isShowIndividual
      if (this.isShowIndividual) {
        this.$nextTick(() => {
          this.$refs.individualRef.clearValidate()
        })
      }
      this.$parent.getIndividual()
      this.getAllTeam()
    },
    // 验证名称是否重复
    checkRepeat () {
      if (!this.userInfo._id) {
        if (this.userInfo.name) {
          Individual.findIndividualName({ name: this.userInfo.name }).then(
            r => {
              if (r.data.length > 0) {
                this.$message({
                  type: 'warning',
                  message: '该个人已存在，请重新输入'
                })
                this.userInfo.name = ''
              }
            }
          )
        }
      } else {
        // 若有 _id ，说明是修改，根据修改前后不同则验证，否则不验证
        Individual.findIndividualName({ _id: this.userInfo._id }).then(r => {
          if (r.data[0].name !== this.userInfo.name) {
            Individual.findIndividualName({ name: this.userInfo.name }).then(
              r => {
                if (r.data.length > 0) {
                  this.$message({
                    type: 'warning',
                    message: '该个人已存在，请重新输入'
                  })
                  this.userInfo.name = ''
                }
              }
            )
          }
        })
      }
    },
    // 上传头像图片验证
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 < 100

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 100KB!')
      }
      return isJPG && isLt2M
    },
    // 删除标签
    handleClose (tag) {
      this.teamTags.splice(this.teamTags.indexOf(tag), 1)
    },
    // 成功上传后执行
    success (res, file) {
      this.imageUrl = res.data
      this.userInfo.avatar = res.data
    },
    // 搜索团队
    teamSearch (queryString, cb) {
      var teams = this.teams
      var results = queryString
        ? teams.filter(this.createFilter(queryString))
        : teams
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return restaurant => {
        return (
          restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    // 获取所有厂牌
    getAllTeam () {
      Individual.findTeam({}).then(r => {
        this.teams = r.data
      })
    },
    // 个人加入团队
    addTag (item) {
      let count = 0
      for (let i = 0; i < this.teamTags.length; i++) {
        if (this.teamTags[i]._id === item._id) {
          count++
        }
      }
      if (count === 0) {
        this.teamTags.push(item) // 将添加内容放到标签中
      }
      this.userInfo.teamIds = this.teamTags
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-wrap {
  min-width: 1200px;
  max-width: 1500px;
  .image {
    width: 100px;
    height: 100px;
    position: absolute;
    right: 180px;
    .avatar-uploader{
      width: 100px;
      height: 100px;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100%;
      text-align: center;
    }
    .avatar {
      width: 100%;
      height: 100px;
      display: block;
    }
  }
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 100px;
  height: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.el-tag + .el-tag {
  margin-left: 10px;
}

.my-autocomplete li {
  line-height: normal;
  padding: 7px;
}
.my-autocomplete li .name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.my-autocomplete li .description {
  font-size: 12px;
  color: #b4b4b4;
}

.my-autocomplete li .highlighted .description {
  color: #ddd;
}
.el-upload,.el-upload--text >i{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
